import { render, staticRenderFns } from "./cardListShop.vue?vue&type=template&id=c01efe4a&scoped=true&"
import script from "./cardListShop.vue?vue&type=script&lang=js&"
export * from "./cardListShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01efe4a",
  null
  
)

export default component.exports